module.exports = __webpack_public_path__ + "img/icon_inquiry_image.8c97d217.png";